import moment from 'moment';

export enum EDateTypes {
  CREATED = 'created_at',
  CANCELED = 'canceled_at',
}

export enum ECustomerSearchTypes {
  NAME = 'customer_name',
  EMAIL = 'customer_email',
  DOCUMENT = 'customer_document',
}

export const DateTypes = [
  { label: 'Início em', value: EDateTypes.CREATED },
  { label: 'Cancelado em', value: EDateTypes.CANCELED },
];

export const CustomerTypes = [
  { label: 'CPF/CNPJ', value: ECustomerSearchTypes.DOCUMENT },
  { label: 'Email', value: ECustomerSearchTypes.EMAIL },
  { label: 'Nome', value: ECustomerSearchTypes.NAME },
];

export const contractStatus = [
  {
    id: 1,
    value: 1,
    label: 'Em Dia',
  },
  {
    id: 2,
    value: 2,
    label: 'Aguardando Pagamento',
  },
  {
    id: 3,
    value: 3,
    label: 'Suspenso',
  },
  {
    id: 4,
    value: 4,
    label: 'Cancelado',
  },
  {
    id: 7,
    value: 7,
    label: 'Atrasado',
  },
  {
    id: 9,
    value: 9,
    label: 'Finalizado',
  },
  {
    id: 10,
    value: 10,
    label: 'Trial',
  },
  {
    id: 11,
    value: 11,
    label: 'Inadimplente',
  },
];

export const PaymentTypes = [
  { id: 2, label: 'Boleto', value: 'boleto' },
  { id: 1, label: 'Cartão de crédito', value: 'credit' },
];

export interface ISubscriptionsFilter {
  date_type: EDateTypes;
  date: string[];
  customer_type?: string;
  customer?: string;
  invoice_id?: string[];
  status?: string[];
  product_id?: any[];
  payment_method: (typeof PaymentTypes)[];
  affiliate_id?: [];
  specific_filters?: [];
  id?: any | any[];
  type?: any[];
  export?: number;
  negotiated_invoices?: boolean;
  unlimited_installment?: boolean;
  open_invoices?: boolean;
  advanced?: boolean;
}

export const initialFilter: ISubscriptionsFilter = {
  date_type: EDateTypes.CREATED,
  date: [moment().subtract(7, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
  customer_type: ECustomerSearchTypes.EMAIL,
  payment_method: [],
  customer: '',
  id: [],
  status: [],
  product_id: [],
  invoice_id: [],
  affiliate_id: [],
  negotiated_invoices: false,
  unlimited_installment: false,
  open_invoices: false,
  type: [],
  advanced: false,
};
